<template>
<div class="container-fluid content-boxes">
    <div class="row">
        <div class="col-md-12 content-back">
                <h2 v-if="pageTitle && pageTitle.length > 0">{{pageTitle[0].text}}</h2>
                <prismic-rich-text :field="sectionText"/>
        </div>
    </div>
    <div v-for="(section,index) of sections" :key="section.id">
         <div class="row content-row even-section" v-if="index % 2 == 0">
            <div class="col-md-8 whatis-brigadeiro" v-if="section && section.primary">
                <div class="title-bar"></div>
                <h2>{{section.primary.section_title[0].text}}</h2>
                <prismic-rich-text :field="section.primary.section_text1"/>
                
            </div> 
            <div class="col-md-4">
                <img v-if="section && section.primary" :src="section.primary.section_image.url" class="img-fluid">
            </div>
        </div>
         <div class="row content-row" v-else >
            <div class="col-md-4 bonjour-order-2">
                <img v-if="section && section.primary" :src="section.primary.section_image.url" class="img-fluid">
            </div>
            
            <div class="col-md-8 whatis-brigadeiro" v-if="section && section.primary">
                <div class="title-bar"></div>
                <h2>{{section.primary.section_title[0].text}}</h2>
                <prismic-rich-text :field="section.primary.section_text1"/>
                
            </div> 
        </div>
       
    </div>
</div>
</template>
<script>

export default {
    name: "Content",
    data(){
        return {
            sectionText: [],
            pageTitle: [],
            sections: []
        }
    },
    methods: {
        getContent(uid){
           this.$prismic.client.getByUID('alt_sections', uid)
          .then((document) => {
            if (document) {
                console.log(document.data);
              this.sections = document.data.body;
              this.sectionText = document.data.section_text;
              this.pageTitle = document.data.page_title;
            } else {
              this.$router.push({ name: 'not-found' })
            }
          })
        }    
    },
    created(){
        this.getContent(this.$route.params.uid)
    },
    mounted(){
        document.querySelector("#pagelogo").classList.addClass('smaller');
        document.querySelector("#pagelogo-a").classList.addClass('smaller');
      
    },
    beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.uid)
    next()
  }
  
}
</script>
<style lang="scss">
.content-boxes {
    margin-top: 75px;
    h2 {
        font-family: "lust-script",sans-serif;
        font-size: 3em;
        color: #300B02;
    }
    .content-back {
        background: url('../assets/img/paris-back.svg') no-repeat bottom;
        //background-size: cover;
        min-height: 99vh;
        padding-left: 60px;
        padding-right: 60px;
        h2 {
            font-family: "raleway",sans-serif;
            font-size: 5em;
        }
    }
    .row {
        margin-left: 0px;
        margin-right: 0px;
    }

    @media (max-width: 680px){
        .bonjour-order-2 {
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        order: 2;
        }
    }
}
</style>